import React from "react";
import LoadingBoxWithoutText from "../../modules/shared/components/LoadingBoxWithoutText";

export default function IsInStock(props) {
  // PROPS COMING FROM PriceOffer
  const { product, isBundleWithStock } = props;

  return (
    <>
      {product.defaultCountInStock ||
      Array.from(product.skus.map((sku) => sku.countInStock)).reduce(
        (a, c) => a + c,
        0,
      ) > 0 ||
      isBundleWithStock ? (
        <div className="countinstock txtcenter">
          <span className="success">Stokta Var</span>
        </div>
      ) : product.isBundle && isBundleWithStock === null ? (
        <div className="countinstock txtcenter">
          <LoadingBoxWithoutText />
        </div>
      ) : (
        <div className="countinstock txtcenter">
          <span className="danger">Stokta Yok</span>
        </div>
      )}
    </>
  );
}
